export default "__VITE_ASSET__BAwuDICq__"